import(/* webpackMode: "eager", webpackExports: ["Home1Client"] */ "/vercel/path0/src/features/home/home1-client.tsx");
